import { Card, CardHeader, CardContent, Box, Unstable_Grid2 as Grid, Paper, List, ListItem, ListItemText, TextField, Typography, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Button } from "@mui/material";
import { AcceptanceDataOutput, DropdownModel, LanguageDataOutout } from "../../data/interfaces/sharedmodels";
import DataTableHeader from "../childcomponents/datatableheader";
import { useCallback, useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { showerrormessage, showsuccessmessage, showwarningmessage } from "../../stores/notificationslice";
import magneticService from "../../data/api/magnetic.service";
import ConfirmDialog from "../confirmdialog";
import { IsEditedContext } from "../../../App";


const PODDisplay = ({ topText, bottomText }: { topText: string, bottomText: string }) => {

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Card variant="outlined" >
                <CardHeader title="E2 Gate Display">

                </CardHeader>
                <CardContent sx={{ textAlign: 'center' }}>
                    <Typography sx={{ backgroundColor: 'lightgray', borderRadius: 1, m: 1, p: 1 }} >{topText}&nbsp;</Typography>
                    <Typography sx={{ backgroundColor: 'lightgray', borderRadius: 1, m: 1, p: 1 }} >{bottomText}&nbsp;</Typography>
                </CardContent>

            </Card>
        </Box>
    )
}
const LanguageList = ({ data,parent,callback }: { data: LanguageDataOutout,parent:string,callback:any }) => {
    const [currentData, setCurrentData] = useState<LanguageDataOutout>(data);
    const [widthArray, setWidthArray] = useState<number[]>([12, 12]);
    const datatbleexpanded = useAppSelector((state) => state.magneticReducer.datatableExpanded);
    const [podTopLineText, setPodTopLineText] = useState<string>('');
    const [podBottomLineText, setBottomPodTopLineText] = useState<string>('');
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const { setIsEdited } = useContext(IsEditedContext) ;
    const dispatch=useAppDispatch();
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    useEffect(() => {
        setCurrentData(data);
    }, [data]);
    useEffect(() => {
        if (currentData.DefaultTexts.length) {
            setPodTopLineText(currentData.DefaultTexts[0].Description);
        }
    }, [currentData]);
    useEffect(() => {
        if (datatbleexpanded) {
            setWidthArray([9, 3]);
        }
        else {
            setWidthArray([12, 12]);
        }
    }, [datatbleexpanded]);

    const onTextChange = (line: number, key: string, value: string) => {
        let tempData = { ...currentData };
        if (line == 1) {
            tempData.TopLineItem.LineTexts.filter(a => a.Id == key)[0].Description = value;
        }
        else {
            tempData.BottomLineItem.LineTexts.filter(a => a.Id == key)[0].Description = value;
        }
        setCurrentData(tempData);
        setIsEdited(true);
    }
    const populateDefault = (line: number) => {
        let tempData = { ...currentData };
        if (line == 1) {
            currentData.DefaultTexts.forEach(element => {
                tempData.TopLineItem.LineTexts.filter(a => a.Id == element.Id)[0].Description = element.Description;
            });

        }
        else {
            currentData.DefaultTexts.forEach(element => {
                tempData.BottomLineItem.LineTexts.filter(a => a.Id == element.Id)[0].Description = element.Description;
            });
        }
        setCurrentData(tempData);
        setIsEdited(true);
    }

    const swapToptoBottom = () => {
        let tempData = { ...currentData };
        let topTexts: DropdownModel[] = [];
        currentData.TopLineItem.LineTexts.forEach(val => topTexts.push(Object.assign({}, val)));
        let bottomTexts: DropdownModel[] = [];
        currentData.BottomLineItem.LineTexts.forEach(val => bottomTexts.push(Object.assign({}, val)));
        bottomTexts.forEach(element => {
            tempData.TopLineItem.LineTexts.filter(a => a.Id == element.Id)[0].Description = element.Description;
        });
        topTexts.forEach(element => {
            tempData.BottomLineItem.LineTexts.filter(a => a.Id == element.Id)[0].Description = element.Description;
        });

        setCurrentData(tempData);
        setIsEdited(true);
    }

    const updatePodDisplay = (key: string) => {
        setPodTopLineText(currentData.TopLineItem.Type==0?'':currentData.TopLineItem.Type==1?
        currentData.DefaultTexts.filter(a => a.Id == key)[0].Description:currentData.TopLineItem.LineTexts.filter(a => a.Id == key)[0].Description);
        setBottomPodTopLineText(currentData.BottomLineItem.Type==0?'':currentData.BottomLineItem.Type==1?
        currentData.DefaultTexts.filter(a => a.Id == key)[0].Description:currentData.BottomLineItem.LineTexts.filter(a => a.Id == key)[0].Description);
    }
    const onRadioChange = (line: number, value: number) => {
        let tempData = { ...currentData };
        let canUpdate=true;
        if (line == 1) {
            if(tempData.BottomLineItem.Type==0&&value==0)
            {
                dispatch(showerrormessage("Cannot update both lines as 'No Language'"));
                canUpdate=false;
            }
            else {
                if(value==0)
                    dispatch(showwarningmessage("It is not recommended to update top line as 'No Language'"));
                tempData.TopLineItem.Type = value;
            }
            
        }
        else {
            if(tempData.TopLineItem.Type==0&&value==0)
            {
                dispatch(showerrormessage("Cannot update both lines as 'No Language'"));
                canUpdate=false;
            }
            else{
                tempData.BottomLineItem.Type = value;
            }
            
        }
        if (canUpdate) {
            setCurrentData(tempData);
            setIsEdited(true);
        }
            
    }
    const handleSave=()=>{
        let modifiedData = { ...currentData };
        modifiedData.Version=selectedVersion??'';
        const updateInput = { NlcId: selectedNlcs.length > 0 ? selectedNlcs[0].Id : 0, TocId: 1, InputData: modifiedData };
        magneticService.updateLanguageData(updateInput).then((response) => {
            if (response && response.data) {
                dispatch(showsuccessmessage("The data is saved successfully."))
                setIsEdited(false);
                callback();
            }
        });
    }

    const handleSetCurrent = () => {
        setDialogTitle('Set Version');
        setDialogMessage('Confirm change of current version to as ' + selectedVersion + '?');

        setDialogOpen(true);
    }

    const setCurrentVersion = useCallback((confirmed: boolean, remarks: string) => {
        setDialogOpen(false);
        if (confirmed) {
            magneticService.setCurrentVersion(selectedVersion ?? "", selectedTable?.Id ?? 0, remarks,selectedNlcs.length? selectedNlcs[0].Id:null).then((response) => {
                if (response.data.IsSuccess) {
                    dispatch(showsuccessmessage(response.data.Message));
                    callback();
                }
                else {
                    dispatch(showerrormessage(response.data.Message))
                }

            });
        }
    }, [selectedTable, selectedVersion])

    return (
        <Box>
            {currentData && currentData.DefaultTexts&& currentData.TopLineItem.LineTexts.length ?
                <Box>
                    <Grid container spacing={1}>
                        <Grid xs={widthArray[0]} container>
                            <Grid container xs={12}>
                                <Grid xs={4}>
                                    <Box component={Paper} sx={{ height: '100%' }}>
                                        <Typography variant="body1" sx={{ p: 1 }}>Click on the default text to view the E2Gate POD Display</Typography>
                                        <Typography sx={{ p: 1 }}>Default Gate Top Line Language Text</Typography>
                                    </Box>
                                </Grid>
                                <Grid xs={4}>
                                    <Box component={Paper} sx={{ p: 1,height: '100%'  }}>
                                        <FormControl>
                                            <FormLabel>Top Line Text Definition(16 character max)</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="deftype-group-label"
                                                value={currentData.TopLineItem.Type}
                                                onChange={(props)=>onRadioChange(1,Number.parseInt(props.target.value)) }
                                                name="deftype-buttons-group"
                                            >{currentData.TypeLookUps.length ? currentData.TypeLookUps.filter(a => a.FieldName == "1")[0].LookUpValues.map((bottomItem) => {
                                                return (
                                                    <FormControlLabel key={'radioT' + bottomItem.Id} value={bottomItem.Id} control={<Radio disabled={!currentData.IsEditable} size="small" />} label={bottomItem.Description} />
                                                )
                                            }) : ''

                                                }
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid xs={4}>
                                    <Box component={Paper} sx={{ p: 1,height: '100%'  }}>
                                        <FormControl>
                                            <FormLabel>Bottom Line Text Definition(20 character max)</FormLabel>
                                            <RadioGroup

                                                aria-labelledby="deftype-group-label-bottom"
                                                value={currentData.BottomLineItem.Type}
                                                onChange={(props)=>onRadioChange(2,Number.parseInt(props.target.value)) }
                                                name="deftype-buttons-group-bottom"
                                            >{currentData.TypeLookUps.length ? currentData.TypeLookUps.filter(a => a.FieldName == "2")[0].LookUpValues.map((bottomItem) => {
                                                return (
                                                    <FormControlLabel  key={'radioB' + bottomItem.Id} value={bottomItem.Id} control={<Radio disabled={!currentData.IsEditable} size="small" />} label={bottomItem.Description} />
                                                )
                                            }) : ''

                                                }
                                            </RadioGroup>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid xs={4}>
                                <Box component={Paper}>
                                    <List sx={{ m: 1 }}>
                                        {currentData.DefaultTexts.map((defaultText) => {
                                            return (
                                                <ListItem key={'defaut' + defaultText.Id} sx={{ cursor: 'pointer', backgroundColor: 'lightgray', borderRadius: 2, mb: 1, p: .5 }}>
                                                    <pre className="margin0">
                                                        <ListItemText  onClick={() => updatePodDisplay(defaultText.Id)}  primary={defaultText.Description} />
                                                    </pre>
                                                </ListItem>
                                            )
                                        })

                                        }
                                    </List>
                                </Box>
                            </Grid>
                            <Grid xs={4}>
                                <Box component={Paper}>
                                    <List sx={{ m: 1 }}>
                                        {currentData.DefaultTexts.map((defaultText) => {
                                            return (
                                                <TextField disabled={!currentData.IsEditable} key={'topline' + defaultText.Id} fullWidth inputProps={{ maxLength: 16 }} size="small" sx={{ mb: 1 }}
                                                    value={currentData.TopLineItem.LineTexts.filter(a => a.Id == defaultText.Id)[0].Description}
                                                    onChange={(event) => onTextChange(1, defaultText.Id, event.target.value)} />
                                            )
                                        })

                                        }
                                    </List>
                                </Box>
                            </Grid>
                            <Grid xs={4}>
                                <Box component={Paper}>
                                    <List sx={{ m: 1 }}>
                                        {currentData.DefaultTexts.map((defaultText) => {
                                            return (
                                                <TextField disabled={!currentData.IsEditable} key={'bline' + defaultText.Id} fullWidth inputProps={{ maxLength: 20 }} size="small" sx={{ mb: 1 }}
                                                    value={currentData.BottomLineItem.LineTexts.filter(a => a.Id == defaultText.Id)[0].Description}
                                                    onChange={(event) => onTextChange(2, defaultText.Id, event.target.value)} />
                                            )
                                        })

                                        }
                                    </List>
                                </Box>
                            </Grid>
                            <Grid xsOffset={4} xs={8}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Button disabled={!currentData.IsEditable} sx={{ m: 1, textTransform: 'none' }} variant="outlined" onClick={() => populateDefault(1)}>Populate with Default Text</Button>
                                    <Button disabled={!currentData.IsEditable} sx={{ m: 1, textTransform: 'none' }} variant="outlined" onClick={() => swapToptoBottom()}>Swap Top-Line and Bottom-Line</Button>
                                    <Button disabled={!currentData.IsEditable} sx={{ m: 1, textTransform: 'none' }} variant="outlined" onClick={() => populateDefault(2)}>Populate with Default Text</Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid xs={widthArray[1]} >
                            <PODDisplay topText={podTopLineText} bottomText={podBottomLineText} />
                        </Grid>

                        <Grid xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between',ml:1,mr:1 }}>
                            {!currentData.ReadOnlyUser&&currentData.Version != selectedVersion ?<Button variant="outlined" onClick={handleSetCurrent}>Set as Current Version</Button>:<div/>}
                                {currentData.IsEditable?<Button variant="contained" onClick={handleSave}>Save</Button>:null}
                                
                            </Box>
                        </Grid>
                    </Grid>
                </Box> : <Typography sx={{ m: 2 }} variant="h6">No data found for the current selection.</Typography>}
                <ConfirmDialog isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={setCurrentVersion} needComments={true} />
        </Box>
    )
}

export default function Languages({ heading, data, parent, versions, callback }:
    { heading: string | undefined, data: LanguageDataOutout, parent: string, versions: DropdownModel[], callback: any }) {
    const [currentData, setCurrentData] = useState<LanguageDataOutout>({
        TableId: 0, Version: '',IsEditable:true,ReadOnlyUser:true, DefaultTexts: [], TopLineItem: {
            LineTexts: [],
            Id: undefined,
            Line: undefined,
            Type: undefined
        }, BottomLineItem: {
            LineTexts: [],
            Id: undefined,
            Line: undefined,
            Type: undefined
        }, TypeLookUps: []
    });
    useEffect(() => {
        if (data && data.DefaultTexts) {
            setCurrentData(data);
        }
    }, [data]);
    return (
        <Card>
            <CardHeader sx={{ pb: 0 }} title={<DataTableHeader heading={heading} parent={parent} versions={versions} />} />
            <CardContent sx={{ p: 1, pt: 0 }}>
                {heading == undefined ? '' : <LanguageList data={currentData} parent={parent} callback={callback}/>}
            </CardContent>
        </Card>
    );
}